const YES_NO_OPTIONS = [
  { value: "sim", label: "Sim" },
  { value: "nao", label: "Não" },
];

const BRAZIL_STATE_OPTIONS = [
  { value: "AC", label: "Acre (AC)" },
  { value: "AL", label: "Alagoas (AL)" },
  { value: "AP", label: "Amapá (AP)" },
  { value: "AM", label: "Amazonas (AM)" },
  { value: "BA", label: "Bahia (BA)" },
  { value: "CE", label: "Ceará (CE)" },
  { value: "DF", label: "Distrito Federal (DF)" },
  { value: "ES", label: "Espírito Santo (ES)" },
  { value: "GO", label: "Goiás (GO)" },
  { value: "MA", label: "Maranhão (MA)" },
  { value: "MT", label: "Mato Grosso (MT)" },
  { value: "MS", label: "Mato Grosso do Sul (MS)" },
  { value: "MG", label: "Minas Gerais (MG)" },
  { value: "PA", label: "Pará (PA)" },
  { value: "PB", label: "Paraíba (PB)" },
  { value: "PR", label: "Paraná (PR)" },
  { value: "PE", label: "Pernambuco (PE)" },
  { value: "PI", label: "Piauí (PI)" },
  { value: "RJ", label: "Rio de Janeiro (RJ)" },
  { value: "RN", label: "Rio Grande do Norte (RN)" },
  { value: "RS", label: "Rio Grande do Sul (RS)" },
  { value: "RO", label: "Rondônia (RO)" },
  { value: "RR", label: "Roraima (RR)" },
  { value: "SC", label: "Santa Catarina (SC)" },
  { value: "SP", label: "São Paulo (SP)" },
  { value: "SE", label: "Sergipe (SE)" },
  { value: "TO", label: "Tocantins (TO)" },
];

const STATUS_OPTIONS = [
  { value: "aberto", label: "Aberto" },
  { value: "pago", label: "Pago" },
];

const ELITESOFT_REQUEST_STATUS_OPTIONS = [
  { value: "abertas", label: "Abertas" },
  { value: "pendentes", label: "Pendentes" },
  { value: "concluidas", label: "Concluídas" },
  { value: "fechadas", label: "Fechadas" },
];

const ELITESOFT_REQUEST_WINDOW_OPTIONS = [
  { value: "30m", label: "Últimos 30 minutos" },
  { value: "60m", label: "Última hora" },
  { value: "6h", label: "Últimas 6 horas" },
  { value: "24h", label: "Últimas 24 horas" },
  { value: "7d", label: "Últimos 7 dias" },
  { value: "custom", label: "Período manual" },
];

const SGP_CONTRACT_STATUS_OPTIONS = [
  { value: "1", label: "Ativo (1)" },
  { value: "2", label: "Inativo (2)" },
  { value: "3", label: "Cancelado (3)" },
  { value: "4", label: "Suspenso (4)" },
  { value: "5", label: "Inviabilidade Técnica (5)" },
  { value: "6", label: "Novo (6)" },
  { value: "7", label: "Ativo V. Reduzida (7)" },
];

const IXC_CONTRACT_STATUS_OPTIONS = [
  { value: "A", label: "Ativo (A)" },
  { value: "I", label: "Inativo/Cancelado (I)" },
  { value: "P", label: "Pré-contrato (P)" },
  { value: "D", label: "Desistência (D)" },
];

const LHISP_STATUS_OPTIONS = [
  { value: "PENDENTE", label: "Pendente" },
  { value: "BLOQUEADO", label: "Bloqueado" },
  { value: "ATIVO", label: "Ativo" },
  { value: "CANCELADO", label: "Cancelado" },
  { value: "SUSPENSO", label: "Suspenso" },
  { value: "DESATIVADO", label: "Desativado" },
];

const SUPERLOGICA_STATUS_OPTIONS = [
  { value: "pendentes", label: "Pendentes" },
  { value: "pagas", label: "Pagas" },
  { value: "canceladas", label: "Canceladas" },
];

const SSOTICA_STATUS_OPTIONS = [
  { value: "aberto", label: "Aberto" },
  { value: "pago", label: "Pago" },
  { value: "cancelado", label: "Cancelado" },
];

const OPEN_INVOICES_ONLY_OPTIONS = [
  { value: "sim", label: "Sim" },
  { value: "nao", label: "Não" },
];

const FINANCIAL_OPEN_INVOICES_MODULE = {
  key: "financial_open_invoices",
  label: "Financeiro",
  endpointPath: "invoices/add",
};

const ELITESOFT_REQUESTS_MODULE = {
  key: "requests",
  label: "Solicitações",
  endpointPath: "requests/add",
  inputs: [
    {
      name: "status_solicitacao",
      type: "select",
      label: "Status da solicitação",
      options: ELITESOFT_REQUEST_STATUS_OPTIONS,
      required: false,
      helpText:
        "Filtro opcional para controle interno da listagem. A fonte principal é a consulta de ocorrências.",
    },
    {
      name: "janela_relativa",
      type: "select",
      label: "Janela de consulta",
      options: ELITESOFT_REQUEST_WINDOW_OPTIONS,
      required: false,
      initialValue: "60m",
      helpText:
        "Define o recorte de tempo para busca das solicitações. Escolha Período manual para informar datas.",
    },
    {
      name: "periodo_dinamico_mensal",
      type: "radio",
      label: "Período Dinâmico Mensal",
      options: YES_NO_OPTIONS,
      initialValue: "nao",
      helpText:
        "Ao habilitar, a listagem usa período dinâmico mensal. Desabilite para informar intervalo manual de datas.",
    },
    {
      name: "data_inicio",
      type: "date",
      label: "Data Inicial",
      requiredWhen: { field: "janela_relativa", equals: "custom" },
    },
    {
      name: "data_fim",
      type: "date",
      label: "Data Final",
      requiredWhen: { field: "janela_relativa", equals: "custom" },
    },
  ],
};

function createVencimentoStatusInputs() {
  return [
    {
      name: "status",
      type: "select",
      label: "Status da fatura",
      options: STATUS_OPTIONS,
      required: true,
    },
    {
      name: "periodo_dinamico_mensal",
      type: "radio",
      label: "Período Dinâmico Mensal",
      options: YES_NO_OPTIONS,
      initialValue: "nao",
      helpText:
        "Ao habilitar, o sistema aplica automaticamente o período de vencimento de 50 dias antes até 15 dias após a data atual. Nesse modo, os campos de data manual ficam desabilitados.",
    },
    {
      name: "data_vencimento_inicio",
      type: "date",
      label: "Data de Vencimento (Início)",
      requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
    },
    {
      name: "data_vencimento_fim",
      type: "date",
      label: "Data de Vencimento (Fim)",
      requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
    },
  ];
}

const HUBSOFT_EXTRA_INPUTS = [
  {
    name: "exibir_pix_copia_cola",
    type: "select",
    label: "Consultar Pix Copia e Cola",
    options: YES_NO_OPTIONS,
  },
  {
    name: "id_carteira_clientes",
    type: "chips",
    label: "Carteira de clientes (IDs)",
    initialValue: [],
    helpText:
      "Informe um ou mais IDs. Separe por vírgula, espaço ou Enter. Exemplo: 1,2,3",
  },
  {
    name: "estado",
    type: "select",
    label: "Estado (UF)",
    options: BRAZIL_STATE_OPTIONS,
    required: false,
    helpText:
      "Opcional. Filtra as faturas por estado com base no endereço de instalação do serviço (ex.: MG).",
  },
];

const SIENGE_EXTRA_INPUTS = [
  {
    name: "paymentTermsId",
    type: "multi_select",
    label: "Tipos de parcela para alerta",
    initialValue: [],
    options: [],
    helpText:
      "Selecione os tipos que devem entrar na cobrança. Esse filtro será enviado como lista de IDs para o backend.",
  },
];

const IXC_EXTRA_INPUTS = [
  {
    name: "id_motivo_cancelamento",
    type: "multi_select",
    label: "Motivos de cancelamento para alerta",
    initialValue: [],
    options: [],
    helpText:
      "Selecione os motivos de cancelamento que devem entrar na cobrança. O filtro será enviado como lista de IDs para o backend.",
  },
];

const IXC_CONTRACTS_MODULE = {
  key: "contracts",
  label: "Contratos",
  endpointPath: "contracts/add",
  inputs: [
    {
      name: "status_contrato",
      type: "select",
      label: "Status do contrato",
      options: IXC_CONTRACT_STATUS_OPTIONS,
      required: false,
    },
    {
      name: "data_cancelamento_inicio",
      type: "date",
      label: "Data de Cancelamento (Início)",
      enabledWhen: { field: "status_contrato", equals: "I" },
      required: false,
    },
    {
      name: "data_cancelamento_fim",
      type: "date",
      label: "Data de Cancelamento (Fim)",
      enabledWhen: { field: "status_contrato", equals: "I" },
      required: false,
    },
    ...IXC_EXTRA_INPUTS,
  ],
};

const MODULES_BY_ERP = {
  "Controllr ISP": [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  HubSoft: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: [
        ...createVencimentoStatusInputs(),
        ...HUBSOFT_EXTRA_INPUTS,
      ],
    },
  ],
  SGP: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: [
        ...createVencimentoStatusInputs(),
        {
          name: "contrato_status",
          type: "multi_select",
          label: "Status do Contrato",
          initialValue: [],
          options: SGP_CONTRACT_STATUS_OPTIONS,
          helpText: "Opcional. Selecione um ou mais status de contrato.",
        },
      ],
    },
  ],
  EliteSoft: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
    ELITESOFT_REQUESTS_MODULE,
  ],
  Sienge: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: [
        ...createVencimentoStatusInputs(),
        ...SIENGE_EXTRA_INPUTS,
      ],
    },
  ],
  "IXC Soft": [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: [
        {
          name: "status_contrato",
          type: "select",
          label: "Status do contrato",
          options: IXC_CONTRACT_STATUS_OPTIONS,
          required: false,
        },
        ...createVencimentoStatusInputs(),
      ],
    },
    IXC_CONTRACTS_MODULE,
  ],
  Voalle: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  "MK Solutions": [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  Atlaz: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  Atlas: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  Asaas: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  Efi: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  EFI: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  "Efí": [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  CobreFacil: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  "Cobre Fácil": [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  "Receita NET": [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  ReceitaNet: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  ISPFY: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: createVencimentoStatusInputs(),
    },
  ],
  "LH ISP": [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: [
        {
          name: "status",
          type: "multi_select",
          label: "Situações do serviço",
          options: LHISP_STATUS_OPTIONS,
          required: false,
          initialValue: [],
        },
        {
          name: "periodo_dinamico_mensal",
          type: "radio",
          label: "Período Dinâmico Mensal",
          options: YES_NO_OPTIONS,
          initialValue: "sim",
          helpText:
            "Ao habilitar, o sistema aplica automaticamente o período de vencimento de 50 dias antes até 15 dias após a data atual.",
        },
        {
          name: "data_vencimento_inicio",
          type: "date",
          label: "Data de Vencimento (Início)",
          requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
        },
        {
          name: "data_vencimento_fim",
          type: "date",
          label: "Data de Vencimento (Fim)",
          requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
        },
      ],
    },
  ],
  "Superlógica Assinaturas": [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: [
        {
          name: "status",
          type: "multi_select",
          label: "Status da cobrança",
          options: SUPERLOGICA_STATUS_OPTIONS,
          required: false,
          initialValue: ["pendentes"],
        },
        {
          name: "periodo_dinamico_mensal",
          type: "radio",
          label: "Período Dinâmico Mensal",
          options: YES_NO_OPTIONS,
          initialValue: "sim",
          helpText:
            "Ao habilitar, o sistema aplica automaticamente o período de vencimento de 50 dias antes até 15 dias após a data atual.",
        },
        {
          name: "data_vencimento_inicio",
          type: "date",
          label: "Data de Vencimento (Início)",
          requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
        },
        {
          name: "data_vencimento_fim",
          type: "date",
          label: "Data de Vencimento (Fim)",
          requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
        },
      ],
    },
  ],
  Superlogica: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: [
        {
          name: "status",
          type: "multi_select",
          label: "Status da cobrança",
          options: SUPERLOGICA_STATUS_OPTIONS,
          required: false,
          initialValue: ["pendentes"],
        },
        {
          name: "periodo_dinamico_mensal",
          type: "radio",
          label: "Período Dinâmico Mensal",
          options: YES_NO_OPTIONS,
          initialValue: "sim",
          helpText:
            "Ao habilitar, o sistema aplica automaticamente o período de vencimento de 50 dias antes até 15 dias após a data atual.",
        },
        {
          name: "data_vencimento_inicio",
          type: "date",
          label: "Data de Vencimento (Início)",
          requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
        },
        {
          name: "data_vencimento_fim",
          type: "date",
          label: "Data de Vencimento (Fim)",
          requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
        },
      ],
    },
  ],
  ssOtica: [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: [
        {
          name: "cnpjs",
          type: "chips",
          label: "CNPJs (filiais)",
          initialValue: [],
          required: true,
          helpText:
            "Informe um ou mais CNPJs (somente números). Exemplo: 28857705000149,27912607000102",
        },
        {
          name: "status",
          type: "multi_select",
          label: "Situação",
          options: SSOTICA_STATUS_OPTIONS,
          required: false,
          initialValue: [],
        },
        {
          name: "periodo_dinamico_mensal",
          type: "radio",
          label: "Período Dinâmico Mensal",
          options: YES_NO_OPTIONS,
          initialValue: "sim",
          helpText:
            "Ao habilitar, o sistema aplica automaticamente o período de vencimento de 50 dias antes até 15 dias após a data atual.",
        },
        {
          name: "data_vencimento_inicio",
          type: "date",
          label: "Data de Vencimento (Início)",
          requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
        },
        {
          name: "data_vencimento_fim",
          type: "date",
          label: "Data de Vencimento (Fim)",
          requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
        },
      ],
    },
  ],
  "F5 ERP": [
    {
      ...FINANCIAL_OPEN_INVOICES_MODULE,
      inputs: [
        {
          name: "apenas_em_aberto",
          type: "radio",
          label: "Apenas em aberto",
          options: OPEN_INVOICES_ONLY_OPTIONS,
          initialValue: "sim",
        },
        {
          name: "periodo_dinamico_mensal",
          type: "radio",
          label: "Período Dinâmico Mensal",
          options: YES_NO_OPTIONS,
          initialValue: "nao",
          helpText:
            "Ao habilitar, o sistema aplica automaticamente o período de vencimento de 50 dias antes até 15 dias após a data atual. Nesse modo, os campos de data manual ficam desabilitados.",
        },
        {
          name: "data_vencimento_inicio",
          type: "date",
          label: "Data de Vencimento (Início)",
          requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
        },
        {
          name: "data_vencimento_fim",
          type: "date",
          label: "Data de Vencimento (Fim)",
          requiredWhen: { field: "periodo_dinamico_mensal", equals: "nao" },
        },
      ],
    },
  ],
};

export function getErpModuleOptions(erpTitle) {
  return MODULES_BY_ERP[erpTitle] || [];
}

export function getErpModuleByKey(erpTitle, moduleKey) {
  return (
    getErpModuleOptions(erpTitle).find((item) => item.key === moduleKey) || null
  );
}
